module.exports = __webpack_public_path__ + "img/affiliateTwo-1.c08d9dd2.png";